require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ilan-goldfajn-has-been-elected-as-the-new-idb-president.json") })
        }
      }, "path---en-us-update-ilan-goldfajn-has-been-elected-as-the-new-idb-president");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ilan-goldfajn-has-been-elected-as-the-new-idb-president!./.cache/json/en-us-update-ilan-goldfajn-has-been-elected-as-the-new-idb-president.json
// module id = 756
// module chunks = 231608221292675